// src/recording/session/ActiveMeasurementSessionContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ActiveMeasurementSessionStore } from "./activeMeasurementSession";

const Ctx = createContext(null);

export function ActiveMeasurementSessionProvider({ children }) {
  const [active, setActive] = useState(ActiveMeasurementSessionStore.get());

  useEffect(() => {
    return ActiveMeasurementSessionStore.subscribe(setActive);
  }, []);

  const api = useMemo(() => {
    return {
      active,
      begin: (mode) => ActiveMeasurementSessionStore.begin(mode),
      end: (reason) => ActiveMeasurementSessionStore.end(reason),
      invalidate: () => ActiveMeasurementSessionStore.invalidate(),
    };
  }, [active]);

  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useActiveMeasurementSession() {
  const v = useContext(Ctx);
  if (!v) {
    throw new Error(
      "useActiveMeasurementSession must be used within ActiveMeasurementSessionProvider",
    );
  }
  return v;
}
